/* Built In Imports */
/* External Imports */
import { Box, Image, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import SectionHeading from '@moms/Headings/SectionHeading';

/* Styles */
import EsteemedSt from '@moms/styleData/EsteemedSt';
/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */

const MainHeading = ({ region, lang, sectionContent }) => {
  const title = sectionContent[0]?.titleText;
  const subtext = sectionContent[0]?.additionalTextLine;
  return (
    <Box
      as="h1"
      display={{ base: 'block', md: 'flex' }}
      textAlign={'center'}
      justifyContent={'center'}
      mb={{ base: '1.5rem', md: '2rem' }}
      gap=".8rem"
      {...EsteemedSt?.[lang]?.title}
    >
      <Text
        as="span"
        color={'#FFFFFF'}
        fontStyle={lang === 'en' ? 'normal' : ''}
      >
        {title}
      </Text>
      <Text
        as="span"
        color={'#EC2224'}
        fontStyle={lang === 'en' ? 'italic' : ''}
        fontWeight={400}
      >
        {' '}
        {subtext}
      </Text>
    </Box>
  );
};

const FlexItems = ({ region, lang, sectionContent }) => {
  const cards = sectionContent[2]?.cards || [];

  return (
    <Box
      maxW={{ base: '100%', md: '990px' }}
      mx={'auto'}
      alignItems={'center'}
      justifyContent={'center'}
      mt={{ base: '2.2rem' }}
      display="flex"
      // flexDir={{ base: 'column', md: 'row' }}
      flexWrap="wrap" // Allows wrapping in case of overflow
      gap={{ base: '1rem', md: '1.5rem' }} // Adds spacing between boxes
    >
      {cards.map((card, index) => (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          key={index}
          bg="#FFFFFF"
          width={{ base: '148px', md: '226px' }}
          height={{ base: '66px', md: '102px' }}
          p={{ base: '10px', md: '15px' }}
        >
          {/* <Link href={card.cardLink || '#'} isExternal> */}
          {/* <Image width="100%" height="100%" /> */}
          <Image
            src={card.thumbnail?.url}
            display={'block'}
            alt={card.thumbnail?.alt || 'Thumbnail'}
            width={{ base: '100%', md: '100%' }}
            mx={'auto'}
            height="100%"
            maxH={{ base: '66px', md: '102px' }}
            objectFit="contain"
          />
          {/* </Link> */}
        </Box>
      ))}
    </Box>
  );
};

const LowerText = ({ region, lang, sectionContent }) => {
  const LowerText = sectionContent[3]?.text;

  return (
    <Text
      mt={{ base: '1.5rem', md: '2.5rem' }}
      mx={'auto'}
      maxW={{ base: '280px', sm: '310px', md: '430px' }}
      {...EsteemedSt?.[lang]?.LowerText}
    >
      {LowerText}
    </Text>
  );
};

const UnitedForWellBeing = ({ region, lang, sectionContent }) => {
  const desc = sectionContent[1]?.text;

  return (
    <Box bgColor={'#010102'} py={'4rem'} px="20px">
      {/* heading  */}
      {/* main heading  */}

      <MainHeading
        region={region}
        lang={lang}
        sectionContent={sectionContent}
      />

      <SectionHeading>{desc}</SectionHeading>
      {/* flex box  container for images  */}

      <FlexItems region={region} lang={lang} sectionContent={sectionContent} />

      <LowerText region={region} lang={lang} sectionContent={sectionContent} />
    </Box>
  );
};

export default UnitedForWellBeing;
